module.exports = __webpack_public_path__ + "static/media/what_img1.43cd4f12.webp";